var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"elevation-0"},[_c('ClassMarkDataTable',{attrs:{"groups":_vm.groups,"singles":_vm.singles,"studentWithMark":_vm.studentWithMark,"headers":_vm.headers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }